import { render, staticRenderFns } from "./us-pc-dialog.vue?vue&type=template&id=b72b15fe"
import script from "./us-pc-dialog.vue?vue&type=script&lang=js"
export * from "./us-pc-dialog.vue?vue&type=script&lang=js"
import style0 from "./us-pc-dialog.vue?vue&type=style&index=0&id=b72b15fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/us-pc-dialog.vue
// module id = null
// module chunks = 